module.exports = "/_next/static/images/image3-8aa9e54da80161626adb6781aa0dede7.png";